var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoDownArrowWhiteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19,
    height: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.706 854.812C454.196 854.325 454.989 854.325 455.486 854.794L455.501 854.812 462.223 861.425 468.943 854.812C469.434 854.325 470.227 854.325 470.723 854.794L470.739 854.812C471.23 855.294 471.236 856.075 470.754 856.562L470.739 856.575 463.12 864.075C462.629 864.562 461.837 864.569 461.34 864.094L461.324 864.075 453.706 856.575C453.209 856.088 453.209 855.3 453.706 854.812Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.11109,
    fill: "#FFFFFF",
    transform: "matrix(1.06875 0 0 1 -484.5 -854.444)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoDownArrowWhiteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-down-arrow-white-icon.146e846b45aa6339005e8c3f932f2e9c.svg";